export const typography = {
  // Display text (for hero sections)
  display1: "text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight",
  display2: "text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight",
  
  // Headings
  h1: "text-2xl md:text-3xl font-bold tracking-tight",
  h2: "text-xl md:text-2xl font-semibold tracking-tight",
  h3: "text-lg md:text-xl font-semibold",
  h4: "text-base md:text-lg font-medium",
  h5: "text-sm md:text-base font-medium",
  h6: "text-xs md:text-sm font-medium",
  
  // Body text
  body: "text-base leading-relaxed",
  bodyLarge: "text-lg leading-relaxed",
  bodySmall: "text-sm leading-normal",
  caption: "text-xs leading-tight",
  
  // Special text styles
  lead: "text-lg md:text-xl text-muted-foreground leading-relaxed",
  muted: "text-sm text-muted-foreground",
  subtle: "text-xs text-muted-foreground/70",
  
  // Feature & marketing
  featureTitle: "text-2xl md:text-3xl font-bold text-foreground tracking-tight",
  featureDescription: "text-base md:text-lg text-muted-foreground leading-relaxed",
  benefitText: "text-base font-medium text-foreground",
  sectionTitle: "text-3xl md:text-4xl font-bold tracking-tight",
  
  // Pricing
  priceAmount: "text-4xl md:text-5xl font-bold tracking-tight",
  priceSuffix: "text-lg text-muted-foreground font-normal",
  
  // Labels & UI
  label: "text-sm font-medium",
  labelSmall: "text-xs font-medium",
  
  // Links
  link: "text-primary hover:text-primary/80 underline-offset-4 hover:underline transition-colors",
};
